import PocketBase from "pocketbase";

export const PocketBaseClient = new PocketBase(
  "https://tooley-watch.com:8080/"
);

// Add custom header to all requests using beforeSend hook
PocketBaseClient.beforeSend = function (url, options) {
  // Ensure headers object exists
  if (!options.headers) {
    options.headers = {};
  }

  // Add custom header to indicate request is from client
  options.headers["x_token"] = "webclient";

  return { url, options };
};

// Admin authentication
export const authenticateAdmin = async () => {
  const adminEmail = process.env.REACT_APP_PB_ADMIN_USERNAME || "";
  const adminPassword = process.env.REACT_APP_PB_ADMIN_PASSWORD || "";

  if (adminEmail && adminPassword) {
    // Use admins.authWithPassword for admin authentication
    return await PocketBaseClient.collection("admins")
      .authWithPassword(adminEmail, adminPassword)
      .then((response) => {
        console.log("Admin authentication response:", response);
        return response;
      })
      .catch((error) => {
        console.error("Admin authentication error:", error);
        throw error;
      });
  } else {
    console.warn(
      "**PocketBase admin credentials not configured. Set REACT_APP_PB_ADMIN_EMAIL and REACT_APP_PB_ADMIN_PASSWORD environment variables."
    );
  }
};
